import React from 'react';
const ReactMarkdown = require('react-markdown');

class StaffSection extends React.Component{

    ref = React.createRef();

    state = {
      width: 0
    }

    componentDidMount(){
      this.setState({
        width: this.ref.current.clientWidth
      })
    }

    render(){
        return (
            <div className="row staff-section">
                <div className="col-10 offset-1">
                    <h1> {this.props.fields.sectionTitle} </h1>
                    <h4> Pastoral Staff </h4>
                    <div className="row staff-section-pastorial">
                        {
                            this.props.fields.pastorialStaff.map((pastor) =>
                                <div className="col-3 staff-section-staff">
                                    <img ref={this.ref} style={{height:this.state.width/1.8}} src={pastor.fields.staffImage.fields.file.url}/>
                                    <div className="staff-section-staff-name"> {pastor.fields.staffName} </div>
                                    <div className="staff-section-staff-role"> {pastor.fields.staffRole} </div>
                                    <div className="staff-section-staff-description"> <ReactMarkdown source={pastor.fields.staffDescription} escapeHtml={false}/> </div>
                                </div>
                            )
                        }
                    </div>

                    <h4> Staff </h4>
                    <div className="row staff-section-normal">
                        {
                            this.props.fields.staff.map((pastor) =>
                                <div className="col-3 staff-section-staff">
                                    <img ref={this.ref} style={{height:this.state.width/1.8}} src={pastor.fields.staffImage.fields.file.url}/>
                                    <div className="staff-section-staff-name"> {pastor.fields.staffName} </div>
                                    <div className="staff-section-staff-role"> {pastor.fields.staffRole} </div>
                                    <div className="staff-section-staff-description"> <ReactMarkdown source={pastor.fields.staffDescription} escapeHtml={false}/> </div>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default StaffSection;
